export default __webpack_public_path__ + "static/media/de.cfbb0cf0.svg";